
import { Component, Prop, Emit, Vue, Watch } from 'vue-property-decorator'
import vFknnTable from './fknnTable.vue'
import vOtherTable from './otherTable.vue'
import vZjhTable from './zjhTable.vue'
import vFishTable from './fishTable.vue'
import vBjlTable from './bjlTable.vue'
import vLhdTable from './lhdTable.vue'
import vHhdzTable from './hhdzTable.vue'
import vHbslTable from './hbslTable.vue'
import vCqbyTable from './cqbyTable.vue'
import vDfdcTable from './dfdcTable.vue'
import vAmfyTable from './amfyTable.vue'
import vGhzTable from './ghzTable.vue'
import vBrnnTable from './brnnTable.vue'
import vTbTable from './tbTable.vue'
import vWxhhTable from './wxhhTable.vue'
import vBcbmTable from './bcbmTable.vue'
import vFqzsTable from './fqzsTable.vue'
import vTtzTable from './ttzTable.vue'
import vWrzjhTable from './wrzjhTable.vue'
import vQznnTable from './qznnTable.vue'
import vErnnTable from './ernnTable.vue'
import vLhcOrderTable from './lhcOrderTable.vue'
import vTwentyOneTable from './twentyOneTable.vue'
import vTbnnTable from './tbnnTable.vue'
import vDdzTable from './ddzTable.vue'
import vSgjTable from './sgjTable.vue'
import vJzwzTable from './jzwzTable.vue'
import vBbwzTable from './bbwzTable.vue'
import vSssTable from './sssTable.vue'
import vErmjTable from './ermjTable.vue'
import vDzpkTable from './dzpkTable.vue'
import vYxxTable from './yxxTable.vue'
import vLhcWinTable from './lhcWinTable.vue'
import vXlmjTable from './xlmjTable.vue'
import vYqcrTable from './yqcrTable.vue'
import vQhhwTable from './qhhwTable.vue'
import vPdkTable from './pdkTable.vue'

@Component({
    components: {
        vOtherTable, //非游戏类流水
        vFknnTable, //疯狂牛牛2009
        vZjhTable, //炸金花2003
        vFishTable, //捕鱼类游戏（捕鱼大战3001、3D捕鱼3002、大闹天宫3003、金蟾捕鱼3004、全名捕鱼3005）
        vBjlTable, //百家乐1007
        vLhdTable, //龙虎斗1005
        vHhdzTable, //红黑大战1006
        vHbslTable, //红包扫雷4001
        vCqbyTable, //传奇霸业5001
        vDfdcTable, //多福多财5002
        vAmfyTable, //澳门风云5004
        vGhzTable, //古惑仔5005
        vBrnnTable, //百人牛牛1002
        vTbTable, //骰宝1001
        vWxhhTable, //五星宏辉1015
        vBcbmTable, //奔驰宝马1009
        vFqzsTable, //飞禽走兽1019
        vTtzTable, //推筒子1010二八杠1016
        vWrzjhTable, //万人炸金花1014
        vQznnTable, //抢庄牛牛2001
        vErnnTable, //二人牛牛2002
        vTwentyOneTable, //21点2008
        vTbnnTable, //同比牛牛2006
        vDdzTable, //斗地主2005
        vSgjTable, //水果机5003
        vJzwzTable, //决战五张1018
        vBbwzTable, //百变五张1017
        vSssTable, //十三水2004
        vErmjTable, //二人麻将2101
        vDzpkTable, //德州扑克2010
        vYxxTable, //鱼虾蟹1020
        vXlmjTable, //血流麻将2102
        vYqcrTable, //一拳超人2011
        vQhhwTable, //秦皇汉武1021
        vPdkTable, //跑得快
        vLhcOrderTable, //六合彩下单6001
        vLhcWinTable //六合彩中奖0
    }
})
export default class AllTable extends Vue {
    valueType = 1
    opttype_name = ''
    table = {
        data: [],
        column: []
    }

    @Prop()
    listdata
    @Watch('listdata', { deep: true })
    watchlistdata(newVal, oldVal) {
        this.table.data = this.listdata
    }

    @Prop()
    sourcenum
    @Watch('sourcenum', { deep: true })
    watchsourcenum(newVal, oldVal) {
        let numstr = this.sourcenum.split('/')
        let num = Number(numstr[0])
        let gameid = Number(numstr[1])
        if (num == 3 || num == 4 || num == 15 || num == 16) {
            this.valueType = gameid
        } else {
            this.valueType = num
        }
    }

    @Prop()
    opttype
    @Watch('opttype', { deep: true })
    watchopttype(newVal, oldVal) {
        this.opttype_name = this.opttype
    }
}
